var ssm = window.ssm || {};

(function (ssm) {
	"use strict";

	ssm.formReload = function (el) {
		var $el = $(el);
		var $form = $el.closest("form");

		var reload = function () {
			$.ajax($el.attr("data-url"), {
				data: $form.serialize(),
			}).done(function (data) {
				$el.html(data);
				ssm.enhance($el);

				var currentTrigger = $el.data("current-input");
				$('[name="' + currentTrigger + '"]')
					.first()
					.change();
			});
		};

		var inputName = $el.attr("data-input");
		$form.on("change", '[name="' + inputName + '"]', reload);
	};

	ssm.formToggleAll = function (el) {
		$(el).on("change", function () {
			var $this = $(this);
			var name = $this.attr("name");
			var checked = this.checked;
			$('input[name="' + name + '"]').prop("checked", checked);
		});
	};

	ssm.formDisableOnAll = function (el) {
		var $el = $(el);
		var $form = $el.closest("form");

		var trigger = $el.data("disable-on-all");

		$form.on("change", '[name="' + trigger + '"]', function () {
			if ($('[name="' + trigger + '"]:checked').val() !== "0") {
				$el.prop("disabled", true);
				$el.prop("checked", false);
			} else {
				$el.prop("disabled", false);
				$el.prop("checked", true);
			}
		});
	};

	ssm.formValidate = function (el) {
		var $el = $(el);
		var formValidation = $el.data("validate");

		/**********************************
		 * Form validation for Cesium databse
		 ***********************************/
		if (formValidation === "cesium") {
			$($el).validate({
				rules: {
					city: "required",
					sampleType: "required",
					result: "required",
				},
				messages: {
					city: $el.find("[data-city-required]").data("city-required"),
					sampleType: $el
						.find("[data-sample-type-required]")
						.data("sample-type-required"),
					result: $el.find("[data-result-required]").data("result-required"),
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		/**********************************
		 * Form validation for environment database
		 ***********************************/
		if (formValidation === "environment") {
			$($el).validate({
				groups: {
					areas: "area allAreas",
				},
				rules: {
					from: { required: true, dateISO: true, minDate: $el.find("[data-from-min]").val() },
					to: { required: true, dateISO: true, maxDate: $el.find("[data-to-max]").val() },
					station: "required",
					nuclide: "required",
				},

				messages: {
					from: {
						required: $el.find("[data-from-required]").data("from-required"),
						dateISO: $el.find("[data-from-valid]").data("from-valid"),
						minDate: $el.find("[data-from-min]").data("from-min"),
					},
					to: {
						required: $el.find("[data-to-required]").data("to-required"),
						dateISO: $el.find("[data-to-valid]").data("to-valid"),
						maxDate: $el.find("[data-to-max]").data("to-max"),
					},
					station: $el.find("[data-station-required]").data("station-required"),
					nuclide: $el.find("[data-nuclide-required]").data("nuclide-required"),
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		/**********************************
		 * Form validation for news subscription page
		 ***********************************/
		if (formValidation === "news") {
			$($el).validate({
				groups: {
					areas: "area allAreas",
				},
				rules: {
					email: "required",
					area: { require_from_group: [1, ".area-group"] },
					allAreas: { require_from_group: [1, ".area-group"] },
					consent: "required",
				},

				messages: {
					email: {
						required: $el.find("[data-email-required]").data("email-required"),
						email: $el.find("[data-email-required]").data("email-valid"),
					},
					area: $el
						.find("[data-all-areas-required]")
						.data("all-areas-required"),
					allAreas: $el
						.find("[data-all-areas-required]")
						.data("all-areas-required"),
					consent: $el.find("[data-consent-required]").data("consent-required"),
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		/**********************************
		 * Form validation for journal page
		 ***********************************/
		if (formValidation === "journal") {
			$($el).validate({
				rules: {
					from: { required: true, dateISO: true },
					to: { required: true, dateISO: true },
				},

				messages: {
					from: {
						required: $el.find("[data-from-required]").data("from-required"),
						dateISO: $el.find("[data-from-valid]").data("from-valid"),
					},
					to: {
						required: $el.find("[data-to-required]").data("to-required"),
						dateISO: $el.find("[data-to-valid]").data("to-valid"),
					},
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		/**********************************
		 * Form validation for journal second tab
		 ***********************************/
		if (formValidation === "journal-diarie") {
			$($el).validate({
				rules: {
					seqno: "required",
				},
				messages: {
					seqno: $el.find("[data-seqno-required]").data("seqno-required"),
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		if (formValidation === "journal-reference") {
			$($el).validate({
				rules: {
					reference: "required",
				},
				messages: {
					reference: $el
						.find("[data-reference-required]")
						.data("reference-required"),
				},
				submitHandler: function (form) {
					form.submit();
				},
			});
		}

		/**********************************
		 * Custom validation
		 ***********************************/

		// Min date
		$.validator.addMethod("minDate", function(value, element, params) {
			var inputDate = new Date(value);
			var minDate = new Date(params);
			if (inputDate >= minDate)
				return true;
			return false;
		}, "Invalid Date!"); 

		// Max date
		$.validator.addMethod("maxDate", function(value, element, params) {
			var inputDate = new Date(value);
			var maxDate = new Date(params);
			if (inputDate <= maxDate)
				return true;
			return false;
		}, "Invalid Date!"); 
	};
})(window.ssm);
